export const dateTimeFormat = "YYYY-MM-DD HH:mm";
export const dateTimeFormatMask = "____-__-__ __:__";
export const dateFormat = "YYYY-MM-DD";
export const dateFormatMask = "____-__-__";
export const dateTimeSecFormat = "YYYY-MM-DD HH:mm:ss";
export const timeFormat = "HH:mm";

export const drawerWidth = 280;
export const toolbarHeight = mobileView => mobileView ? 60 : 100;

export const adminFinTechRight = ['ADMIN', 'CP_FIN','CP_TECH'];
export const adminFinRight = ['ADMIN', 'CP_FIN'];
export const adminTechRight = ['ADMIN', 'CP_TECH'];

export const tpRights = [
  "TECHPORTAL_USER",
  "Invitech_SMC VIP",
  "Sec Officer",
  "IT_DIR",
  "TP_TEST",
  "ITH_IT_DEVOPS",
  "_IT_alkalmazas_architekt",
  "_corpco",
  "_ICT_Hosting_Üzemeltetési_Csoport",
  "_ICT_DC_ Infrastruktúra_Üzemeltetési_Csoport",
  "TP_DC_POWER_METER",
  "TP_DC_POWER_METER_VIEW",
  "SDWAN",
  "TP_SDWAN_VIEWER",
  "TP_PERF_MONITORING",
  "Invitech SMC",
  "_ICT_Command_Center",
  "Transmission",
  "Mikro",
  "_ICT_TDA",
  "Tranziens_team",
  "PERFMON",
  "DDOS",
  "TP_SECURITY_DASHBOARD",
  "K8SM",
  "TP_K8SM",
  "SOC",
  "Security Dashboard",
  "DNS",
  "TP_DNS",
  "_ICT_L2_IPOP",
  "Invitech SMC VIP",
  "_ipoprouter",
  "DCPOWER"
];
